<template>
  <VisitLink>
    <div
      class="inline-block px-4 py-4 font-bold leading-none text-black no-underline rounded-sm offerCtaCell whitespace-nowrap"
    >
      <span>{{ value.offer.ctaText }}</span>
    </div>
  </VisitLink>
</template>
<script>
import VisitLink from '@/components/visit-link'

export default {
  name: 'OfferCtaCell',
  components: {
    VisitLink,
  },
  props: {
    /**
     * The required cell data.
     * Required values: { href, ctaText }
     */
    value: {
      type: Object,
      required: true,
      validator(value) {
        return 'offer' in value && value.offer.ctaText
      },
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/styles/cta-animation.scss';

.offerCtaCell {
  background-size: 400% 400%;
  animation: BackgroundWave 2s ease infinite;
  background: linear-gradient(138deg, #f8bc00, #f8cd46);

  &:hover {
    background-size: 400% 400%;
    animation: BackgroundWaveHover 1s ease infinite;
  }
}
</style>
